import { useEffect, useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import { listRiskMatrixService } from "../services/listRiskMatrix.service";

export const useRiskMatrixQuery = (filters) => {
  const fetchData = useFetch();
  const [riskMatrix, setRiskMatrix] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchRiskMatrix = async () => {
      try {
        setLoading(true);
        const response = await listRiskMatrixService(fetchData)({
          filters: { limit: 25, page: currentPage, ...filters },
        });
        setRiskMatrix(response.data);
        setTotal(response.total);
        setTotalPages(response.totalPages);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchRiskMatrix();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, filters, currentPage]);

  return {
    riskMatrix,
    loading,
    refresh: () => setRefresh(!refresh),
    total,
    currentPage,
    onChangePage: (page) => setCurrentPage(page),
    totalPages,
  };
};
